import RouterLink from './router-link.element.js';

export default RouterLink;

RouterLink.define('wje-router-link', RouterLink);
